module.exports = __webpack_public_path__ + "img/farzana-christopher-55.53aca9e0.jpg";